import * as loginReauthentication from "@JS/shop/10-login-component/loginReauthentication";

// DOM
let $addressBox;
let $paymentAddress;
let $deliveryAddress;
let $paymentBox;

// Classes
let addressRemove;
let preview;
let edit;
let headerbox;

function init() {
	// Dependencies

	// DOM
	$addressBox = $(".js-checkout-address");
	$paymentAddress = $(".js-checkout-payment-address");
	$deliveryAddress = $(".js-checkout-delivery-address");
	$paymentBox = $(".js-checkout--payment");

	addressRemove = ".js-checkout-address-remove";
	preview = ".js-checkout-preview";
	edit = ".js-checkout-header-edit";
	headerbox = ".js-checkout-header-box";

	// Bindings
	$addressBox.each(function () {
		const $this = $(this);
		const addressId = $(this).attr("data-id");
		$this.find(addressRemove).on("click", null, addressId, _addressRemove);
	});
}

function _addressRemove(event) {
	loginReauthentication.precheckSessionState(); // todo: TUB-9245 login2020

	event.preventDefault();
	event.stopPropagation();

	const $addressBox = $(event.currentTarget).closest(".js-checkout-address");
	const isSelectedPayment = $addressBox.hasClass("is-selected") && $addressBox.hasClass("is-payment-address");

	const url = $(event.currentTarget).attr("data-delete-url");

	const CSRFToken = $("form").find("input[name='CSRFToken']").val();

	const addressId = event.data;
	const $addressToRemove = $addressBox.filter(`[data-id=${addressId}]`);
	const $paymentAddressPreviewToRemove = $paymentAddress.find(preview).filter(`[data-id=${addressId}]`);
	const $deliveryAddressPreviewToRemove = $deliveryAddress.find(preview).filter(`[data-id=${addressId}]`);

	$addressToRemove.parent("div").remove();

	$paymentAddressPreviewToRemove.remove();

	if ($deliveryAddressPreviewToRemove.length > 0) {
		$deliveryAddressPreviewToRemove.remove();
	}
	if (isSelectedPayment) {
		$deliveryAddress.find(edit).remove();
		$deliveryAddress.find(headerbox).addClass("is-disabled");
		$paymentBox.find(edit).remove();
		$paymentBox.find(headerbox).addClass("is-disabled");
	}

	$.ajax({
		type: "POST",
		url,
		data: JSON.stringify({ CSRFToken, addressCode: addressId }),
		contentType: "application/json",
	})
		.done((response) => {
			console.log(response);
		})
		.fail((error) => {
			console.log(error);
		});
}

export { init };
